import React, { useEffect }  from "react";
import { connect } from "react-redux";
import CardContainer from "components/card";
import { List, Card, Row, Col } from "antd";
import { getAnimalTransferList } from "../../../../redux/farmanimal/farmAnimalState";
import { renderLabel } from '../../../../utils/index';
const AnimalTransfers = ({recordList, recordId, doSearch, ...props}) => {
	
	useEffect(() => {
		doSearch({animalId: recordId});
	}, [doSearch, recordId]);

	return (
		<div className="flex w-full">
			<CardContainer extra="w-full p-[20px]">
				
				<List
					itemLayout="vertical"
    				size="large"
					dataSource={recordList}
					renderItem={(item) => (
					<List.Item>
						<Card size="small">
							<Card.Meta title={item.original_tag_id}/>
							<Row gutter={16} className="mt-4">
								<Col span={12}>
									<Card size="small" title={`From: ${item.original_tag_id}`}>
										<div>
											<label className="font-bold">Account Name: </label>
											{item.from_account_name}
										</div>
										<div>
											<label className="font-bold">Farm Location: </label>
											{item.from_farm_name}
										</div>
									</Card>
								</Col>
								<Col span={12}>
									<Card size="small" title={`To: ${item.animal?.tag_id}`}>
										<div>
											<label className="font-bold">Account Name: </label>
											{item.to_account_name}
										</div>
										<div>
											<label className="font-bold">Farm Location: </label>
											{item.to_farm_name}
										</div>
									</Card>
								</Col>
							</Row>
							<Row gutter={16} >
								<Col span={24}>
									<div className="p-2">
										<div className="font-bold">Remarks: </div>
										<div>{item.remarks ?? '-' }</div>
									</div>
								</Col>
								<Col span={12}>
									<div className="p-2">
										<div className="font-bold">Process By: </div>
										<div>{item.created_by?.username}</div>
									</div>
								</Col>
								<Col span={12}>
									<div className="p-2">
										<div className="font-bold">Process Date: </div>
										<div>{item.created_at}</div>
									</div>
								</Col>
							</Row>
						</Card>
					</List.Item>
					)}
				/>
			</CardContainer>
		</div>
    );
};

const mapStateToProps = (state) => ({
	recordList: state.farmAnimal.transferList?.items,
	filters: state.farmAnimal.transferList?.filters,
  	requesting: state.farmAnimal.transferList?.requesting,
  	error: state.farmAnimal.transferList?.error,	
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getAnimalTransferList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AnimalTransfers);